import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FormError } from '@/core/FormError.atom';
import { Button, Select } from '@seeqdev/qomponents';

type SelectOption = {
  value: string;
  label: string;
};

type GroupedSelectOption = {
  label: string;
  options: SelectOption[];
};

export type SelectAndAddProps = {
  selectedItemIds: string[];
  options: SelectOption[] | GroupedSelectOption[];
  selectedValue: SelectOption | GroupedSelectOption;
  onChange: (value: SelectOption) => void;
  onAddClick: () => void;
  isAssetAndItemSelected?: boolean;
  isSelectAllDisabled?: boolean;
};

/**
 * Contains dropdown and add button for multi-select.
 *
 * Manages loading state for add button
 */
export const SelectAndAdd = ({
  selectedItemIds,
  options,
  selectedValue,
  onChange,
  onAddClick,
  isAssetAndItemSelected,
  isSelectAllDisabled,
}: SelectAndAddProps) => {
  const { t } = useTranslation();

  const [isLoading, setLoading] = useState(false);

  const renderResult = () => {
    if (isAssetAndItemSelected) {
      return <FormError errorText="MULTI_SELECT.ASSET_GROUP.ERROR" />;
    }

    if (selectedItemIds.length > 0) {
      return (
        <div className="flexColumnContainer tw:items-center" data-testid="selectAndAddEmptyWrapper">
          <Select
            id="selectActionsOptions"
            small={true}
            extraClassNames="flexFillOverflow mr10"
            value={selectedValue}
            options={options}
            onChange={onChange}
            isSearchable={false}
            isClearable={false}
          />
          <Button
            testId="addItems"
            variant="theme"
            size="sm"
            disabled={isLoading}
            label={t('ADD')}
            inProgress={isLoading}
            onClick={() => {
              setLoading(true);
              onAddClick();
            }}
          />
        </div>
      );
    }

    if (isLoading) {
      setLoading(false);
    }

    return <span className={clsx({ disabledLook: isSelectAllDisabled })}>{t('SELECT_ALL')}</span>;
  };

  return (
    <div data-testid="selectAndAdd" className="width-maximum tw:ml-sq-5">
      {renderResult()}
    </div>
  );
};
